/**
 * @description
 * @param {*} percentage
 * @returns - String representing the color
 */
export const calculateRatingColor = (percentage) => {
  const numericPercentage = parseInt(percentage, 10);
  if (numericPercentage >= 80) {
    return '#D6FFC1';
  }

  if (numericPercentage >= 41) {
    return '#FFFDC4';
  }

  return '#FFCDCD';
};
